module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', [_c('div', {
    staticClass: "title"
  }, [_vm._v("Cadastro de participante não vinculado à UNIFEBE")])]), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [(!_vm.submitted) ? _c('div', [_c('v-select', {
    attrs: {
      "label": "Nacionalidade",
      "prepend-icon": "",
      "items": _vm.nationalities,
      "item-text": "name",
      "item-value": "id"
    },
    model: {
      value: (_vm.person.nationality),
      callback: function($$v) {
        _vm.$set(_vm.person, "nationality", $$v)
      },
      expression: "person.nationality"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": _vm.documentLabel,
      "prepend-icon": "assignment_ind",
      "rules": _vm.rules.document,
      "mask": _vm.documentMask,
      "required": "",
      "validate-on-blur": ""
    },
    model: {
      value: (_vm.person.document),
      callback: function($$v) {
        _vm.$set(_vm.person, "document", $$v)
      },
      expression: "person.document"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Nome",
      "prepend-icon": "text_fields",
      "rules": _vm.rules.name,
      "required": ""
    },
    model: {
      value: (_vm.person.name),
      callback: function($$v) {
        _vm.$set(_vm.person, "name", $$v)
      },
      expression: "person.name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Data de Nascimento",
      "prepend-icon": "date_range",
      "rules": _vm.rules.date,
      "mask": "##/##/####",
      "required": "",
      "validate-on-blur": ""
    },
    model: {
      value: (_vm.person.birthDate),
      callback: function($$v) {
        _vm.$set(_vm.person, "birthDate", $$v)
      },
      expression: "person.birthDate"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "E-mail",
      "prepend-icon": "email",
      "rules": _vm.rules.email,
      "required": "",
      "validate-on-blur": ""
    },
    model: {
      value: (_vm.person.email),
      callback: function($$v) {
        _vm.$set(_vm.person, "email", $$v)
      },
      expression: "person.email"
    }
  }), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "dark": "",
      "large": ""
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("Cadastrar")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.submitted) ? _c('div', [_c('v-alert', {
    attrs: {
      "value": _vm.wasCreated,
      "color": "success"
    }
  }, [_vm._v("Seu cadastro foi realizado com sucesso.")]), _vm._v(" "), _c('v-alert', {
    attrs: {
      "value": _vm.alreadyExists,
      "color": "warning"
    }
  }, [_vm._v("Já existe um usuário cadastrado para o " + _vm._s(_vm.documentLabel) + " " + _vm._s(_vm.person.document) + " com o e-mail " + _vm._s(_vm.exists.email) + ".")]), _vm._v(" "), _c('v-alert', {
    attrs: {
      "value": _vm.canSendAccess && !_vm.accessSent,
      "color": "info"
    }
  }, [_vm._v("Se desejar, clique em "), _c('strong', [_vm._v("Enviar acesso")]), _vm._v(" para receber no seu e-mail cadastrado um código e senha de acesso ao Sistema de Gestão de Bancas.")]), _vm._v(" "), (_vm.canSendAccess && !_vm.accessSent) ? _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "info",
      "dark": "",
      "large": ""
    },
    on: {
      "click": _vm.sendAccess
    }
  }, [_vm._v("Enviar acesso")])], 1) : _vm._e(), _vm._v(" "), _c('v-alert', {
    attrs: {
      "value": _vm.accessSent,
      "color": "success"
    }
  }, [_vm._v("Um e-mail foi enviado para " + _vm._s(_vm.accessSentTo) + " com o código e senha para acesso ao Sistema de Gestão de Bancas.")]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-center",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "to": "/entrar/visitante",
      "color": "primary",
      "dark": "",
      "large": ""
    }
  }, [_vm._v("Fazer login")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('v-alert', {
    attrs: {
      "value": true,
      "color": "error"
    }
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.showActions) ? _c('v-card-actions', [_vm._t("actions")], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1dc8f2d6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RegisterExternalListener.vue
// module id = 243
// module chunks = 0